import React from 'react';
import * as PropTypes from "prop-types";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import TableCell from "@material-ui/core/TableCell";
import {withStyles} from '@material-ui/core/styles';
import PlantManagementUtility from "./PlantManagementUtility";

const styles = theme => ({
    header: {
        backgroundColor: 'skyblue',
        width: theme.spacing.unit * 10,
        maxWidth: theme.spacing.unit * 10,
        margin: 'auto 0',
        textAlign: 'center',
        fontSize: '1rem'
    },
    datetime: {
        margin: 'auto 0',
        minWidth: theme.spacing.unit * 20,
        maxWidth: theme.spacing.unit * 20,
        fontSize: '1rem'
    },
    toggleSwitch: {
        paddingLeft: theme.spacing.unit * 2
    },
    formControlLabelRoot: {
        height: 34,
    },
    formControlLabelLabel: {
        fontSize: '1rem',
    }
});

const CustomTableCell = (props) => {
    return (<TableCell size={'small'} align={"center"} className={props.className} padding={"none"}>{props.children}</TableCell>)
};

class HeatExchangerProcessTableCell extends React.Component {
    render() {
        return (
            <CustomTableCell>
                <Grid container component={'div'}>
                    <Grid item xs={3} component={'div'} className={this.props.classes.header}>{this.props.headerLabel}</Grid>
                    <Grid item xs={4} component={'div'} className={this.props.classes.toggleSwitch}>
                        <FormControlLabel
                            control={<Switch color="primary" checked={PlantManagementUtility.isParamTrue(this.props.resultOfProcessIsComplete)}/>}
                            label={"完了"}
                            onChange={this.props.onChange}
                            disabled={this.props.isDisable}
                            className={this.props.classes.formControlLabelRoot}
                            classes={{label: this.props.classes.formControlLabelLabel}}
                        />
                    </Grid>
                    <Grid item xs={5} component={'div'} className={this.props.classes.datetime}>
                        {this.props.isDisable ?
                            "対象なし"
                            :
                            PlantManagementUtility.isParamTrue(this.props.resultOfProcessIsComplete) ? this.props.resultOfProcessDatetime : ''
                        }
                    </Grid>
                </Grid>
            </CustomTableCell>
        );
    }
}

HeatExchangerProcessTableCell.propTypes = {
    headerLabel: PropTypes.string.isRequired,
    isDisable: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    resultOfProcessDatetime: PropTypes.string.isRequired,
    resultOfProcessIsComplete: PropTypes.string.isRequired
};

export default withStyles(styles)(HeatExchangerProcessTableCell);
